import React from 'react';
import styled from 'styled-components';

/*
 * Inactive field for rendering the summary page.
 */

export const Wrapper = styled.div`
  width: 360px;
  text-align: center;
  margin: auto;
  margin-top: 20px;

  &:not(:last-child)::after {
    margin-top: 30px;
    display: block;
    content: '';
    height: 0px;
    border-bottom: solid 1px ${props => props.theme.primaryAlt};
  }
`;

export const Label = styled.div`
  color: ${props => props.theme.primary}
  font-size: 16px;
`;
const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  color: ${props => props.theme.secondary};
  fill: ${props => props.theme.primary};
  font-size: 14px;
  min-height: 14px;
`;

// Icon width 30px and margin with text 20px
// -50px left margin to make text appear centered
const IconWrapper = styled.span`
  margin-left: -50px;
  margin-right: 20px;
`;

const renderIcon = (getter, value) => {
  if (!getter) {
    return null;
  }
  const Icon = getter(value);
  return (
    <IconWrapper>
      <Icon width={30} height={30} />
    </IconWrapper>
  );
};

const SummaryField = ({
  label,
  getIcon,
  displayValue,
  input: { value },
  meta: { error },
  hide,
}) => {
  if (hide && hide(value)) {
    return null;
  }
  return (
    <Wrapper>
      <Label>{label}</Label>
      <Text>
        {renderIcon(getIcon, value)}
        {(displayValue && displayValue(value)) || value || '-'}
      </Text>
      {error}
    </Wrapper>
  );
};

export default SummaryField;
